import { render, staticRenderFns } from "./CaseFormAccount.vue?vue&type=template&id=2677eb9c&scoped=true&"
import script from "./CaseFormAccount.vue?vue&type=script&lang=ts&"
export * from "./CaseFormAccount.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFormAccount.vue?vue&type=style&index=0&id=2677eb9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2677eb9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
